// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1W2Bm","sendOtp":"AuthorizeToLogin_sendOtp__1vuEO"};